// class CartNotification extends HTMLElement {
//   constructor() {
//     super();

//     this.notification = document.getElementById('cart-notification');
//     this.header = document.querySelector('sticky-header');
//     this.onBodyClick = this.handleBodyClick.bind(this);

//     this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
//       closeButton.addEventListener('click', this.close.bind(this))
//     );
//   }

//   open() {
//     this.notification.classList.add('animate', 'active');

//     this.notification.addEventListener(
//       'transitionend',
//       () => {
//         this.notification.focus();
//         trapFocus(this.notification);
//       },
//       { once: true }
//     );

//     document.body.addEventListener('click', this.onBodyClick);
//   }

//   close() {
//     this.notification.classList.remove('active');
//     document.body.removeEventListener('click', this.onBodyClick);

//     removeTrapFocus(this.activeElement);
//   }

//   renderContents(parsedState) {
//     this.cartItemKey = parsedState.key;
//     this.getSectionsToRender().forEach((section) => {
//       document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
//         parsedState.sections[section.id],
//         section.selector
//       );
//     });

//     if (this.header) this.header.reveal();
//     this.open();
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-notification-product',
//         selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
//       },
//       {
//         id: 'cart-notification-button',
//       },
//       {
//         id: 'cart-icon-bubble',
//       },
//     ];
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   handleBodyClick(evt) {
//     const target = evt.target;
//     if (target !== this.notification && !target.closest('cart-notification')) {
//       const disclosure = target.closest('details-disclosure, header-menu');
//       this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
//       this.close();
//     }
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-notification', CartNotification);


class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    // Close on escape
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    // Close buttons inside notification
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    const buttonLoader = document.querySelector('.product-form__submit .loading__spinner');
    const submitButton = document.querySelector('.product-form__submit');
    submitButton.classList.remove('loading');
    submitButton.setAttribute('aria-disabled', 'false');
    buttonLoader.classList.add('hidden');
    const cartButton = document.querySelector('#shopify-section-cart-notification-button');

    if (cartButton) {
      // Split text into words and number
      const match = cartButton.textContent.match(/^(.+?)\s*(\(\d+\))$/);
      if (match) {
        const numberPart = match[2]; // e.g., (3)
        cartButton.textContent = `VIEW SHOPPING BAG ${numberPart}`;
      }
    }
    
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    // Inject HTML from JSON
    Object.keys(parsedState.sections).forEach((sectionId) => {
      const el = document.getElementById(sectionId);
      if (!el) return;
      el.innerHTML = parsedState.sections[sectionId];
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);


document.addEventListener('DOMContentLoaded', () => {
  const cartNotification = document.querySelector('cart-notification');

  if (!cartNotification) return;

  document.querySelectorAll('[data-type="add-to-cart-form"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const submitButton = form.querySelector('[type="submit"]');
      submitButton.disabled = true;

      const formData = new FormData(form);

      try {
        // Add to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) throw new Error('Failed to add to cart');

        const data = await response.json();

        // Fetch updated cart notification JSON
        const notifResponse = await fetch('/?sections=cart-notification-product,cart-notification-button,cart-icon-bubble', {
          headers: { 'Accept': 'application/json' }
        });
        const sections = await notifResponse.json();

        cartNotification.renderContents({
          key: data.key,
          sections: sections
        });
      } catch (error) {
        console.error('Add to cart error:', error);
      } finally {
        submitButton.disabled = false;
      }
    });
  });
});

// Trap focus helpers
function trapFocus(element) {
  const focusableEls = element.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  const firstEl = focusableEls[0];
  const lastEl = focusableEls[focusableEls.length - 1];

  element.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;

    if (e.shiftKey && document.activeElement === firstEl) {
      e.preventDefault();
      lastEl.focus();
    } else if (!e.shiftKey && document.activeElement === lastEl) {
      e.preventDefault();
      firstEl.focus();
    }
  });

  firstEl.focus();
}

function removeTrapFocus(element) {
  if (element) element.focus();
}